import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function BusinessAnalystSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["business-analyst"]} />;
}
